module.exports = __webpack_public_path__ + "img/google-calendar.2e99a2d.png";